import { useMemo } from 'react';

// styles
import {
    QueueCardContainer,
    CardDetails,
    CardHeader,
    CardNumber,
    AttributesContainer,
    CardContent,
    LeftCardContent,
} from './QueueCardCustom.styles';

import { QueueOddsRow } from '../../QueuedCards.styles.js';
import {
    findParallelDefinition,
    getDefinedOddsEntries,
    formatOddsForDisplay,
    queueParallelAttributeText,
} from '../../utils/queueParallelOdds.js';

// assets
import CardAttribute from '../../../card-attribute/CardAttribute';

export default function QueueCardCustom({ card, index, parallel, selectedOddsProducts = null, parallelData = [] }) {
    const showOdds = selectedOddsProducts && selectedOddsProducts.length > 0;

    const oddsPairs = useMemo(() => {
        if (!showOdds || !parallelData?.length) return [];
        const def = findParallelDefinition(parallelData, parallel);
        const allPairs = getDefinedOddsEntries(def?.odds);
        if (selectedOddsProducts.includes('all')) return allPairs;
        return allPairs.filter(([product]) => selectedOddsProducts.includes(product));
    }, [showOdds, selectedOddsProducts, parallelData, parallel]);

    return (
        <QueueCardContainer className='panel-bg dropshadow'>
            <CardContent>
                <LeftCardContent>
                    <CardNumber>
                        <h4>{card.card.cardNumber}</h4>
                    </CardNumber>
                    <CardDetails>
                        <CardHeader>
                            {card.card.name.map((name, index) => (
                                <span key={index}>
                                    <h3>{name}</h3>
                                    {index < card.card.name.length - 1 && ' • '}
                                </span>
                            ))}
                        </CardHeader>
                        {(card.card.cardAttributes?.length > 0 || card.card.collectedCards?.length > 0) &&
                            <AttributesContainer>
                                {card.card.cardAttributes?.length > 0 &&
                                    card.card.cardAttributes.map(attribute => (
                                        <CardAttribute key={attribute} text={attribute} />
                                    ))
                                }

                                {card.card.cardAttributes?.length > 0 && card.card.collectedCards?.length > 0 &&
                                    <h4>•</h4>
                                }

                                {card.card.collectedCards.map((collectedParallel) => {
                                    const borderColor = collectedParallel.cardColor ? collectedParallel.cardColor : '#FFFFFF';
                                    return (
                                        <CardAttribute
                                            key={collectedParallel.cardParallelName}
                                            color={borderColor}
                                            text={queueParallelAttributeText(collectedParallel)}
                                        />
                                    );
                                })}
                            </AttributesContainer>
                        }
                    </CardDetails>
                </LeftCardContent>
            </CardContent>
            {showOdds && oddsPairs.length > 0 && (
                <QueueOddsRow>
                    {oddsPairs.map(([product, value]) => (
                        <CardAttribute
                            key={product}
                            text={`${product}: ${formatOddsForDisplay(value)}`}
                        />
                    ))}
                </QueueOddsRow>
            )}
        </QueueCardContainer>
    );
}
